import { render, staticRenderFns } from "./editBigExcellence.vue?vue&type=template&id=0a2c1416&"
import script from "./editBigExcellence.vue?vue&type=script&lang=js&"
export * from "./editBigExcellence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports